module.exports = __webpack_public_path__ + "static/media/emea-order-entry.dbad2fb7.svg";